import React from 'react'

const Gld10 = () => {
    return (
        <div className='container'>
        <h1>Intersection of two Sorted Linked Lists</h1>
        <p>Given two lists sorted in increasing order, create and return a new list representing the intersection of the two lists. The new list should be made with its own memory — the original lists should not be changed.&nbsp;</p>
        <p><strong>Example:</strong>&nbsp;</p>
        <pre className='containers'><strong>Input: </strong>
First linked list: 1-&gt;2-&gt;3-&gt;4-&gt;6 <br />
Second linked list be 2-&gt;4-&gt;6-&gt;8,  <br />
<strong>Output:</strong> 2-&gt;4-&gt;6. <br />
The elements 2, 4, 6 are common in  <br />
both the list so they appear in the  <br />
intersection list.  <br />
<br />
<strong>Input: </strong> <br />
First linked list: 1-&gt;2-&gt;3-&gt;4-&gt;5 <br />
Second linked list be 2-&gt;3-&gt;4,  <br />
<strong>Output:</strong> 2-&gt;3-&gt;4 <br />
The elements 2, 3, 4 are common in  <br />
both the list so they appear in the  <br />
intersection list.</pre> <br />
<p><strong><u>Solution</u>:</strong> Recursive Solution.&nbsp;<br/>
<strong>Approach:</strong>&nbsp;<br/>
The recursive approach is very similar to the the above two approaches. Build a recursive function that takes two nodes and returns a linked list node. Compare the first element of both the lists.&nbsp;</p>     
    <div class="tabs">
       <input type="radio" name="tab" id="tab1" />
       <label for="tab1">CPP</label>
       <input type="radio" name="tab" id="tab2"/>
       <label for="tab2">C </label>
      
     
       <div class="tab-content-wrapper">
         <div id="tab-content-1" class="tab-content">
         <div class="container">
<div class="line number1 index0 alt2"><code class="preprocessor">#include &lt;bits/stdc++.h&gt;</code></div>
<div class="line number2 index1 alt1"><code class="keyword bold">using</code> <code
        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
<div class="line number3 index2 alt2">&nbsp;</div>
<div class="line number4 index3 alt1"><code class="comments">// Link list node</code></div>
<div class="line number5 index4 alt2"><code class="keyword bold">struct</code> <code class="plain">Node</code></div>
<div class="line number6 index5 alt1"><code class="plain">&#123;</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* next;</code></div>
<div class="line number9 index8 alt2"><code class="plain">&#125;;</code></div>
<div class="line number10 index9 alt1">&nbsp;</div>
<div class="line number11 index10 alt2"><code class="keyword bold">struct</code> <code
        class="plain">Node* sortedIntersect(</code><code class="keyword bold">struct</code> <code
        class="plain">Node* a,</code></div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* b)</code></div>
<div class="line number13 index12 alt2"><code class="plain">&#123;</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// base case</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(a == NULL || b == NULL)</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">NULL;</code></div>
<div class="line number18 index17 alt1">&nbsp;</div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* If both lists are non-empty */</code></div>
<div class="line number20 index19 alt1">&nbsp;</div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Advance the smaller list and</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">call recursively */</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(a-&gt;data &lt; b-&gt;data)</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">sortedIntersect(a-&gt;next, b);</code></div>
<div class="line number25 index24 alt2">&nbsp;</div>
<div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(a-&gt;data &gt; b-&gt;data)</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">sortedIntersect(a, b-&gt;next);</code></div>
<div class="line number28 index27 alt1">&nbsp;</div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Below lines are executed only</code></div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// when a-&gt;data == b-&gt;data</code></div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* temp = (</code><code
        class="keyword bold">struct</code> <code class="plain">Node*)</code><code
        class="functions bold">malloc</code><code class="plain">(</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
        class="plain">Node));</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp-&gt;data = a-&gt;data;</code></div>
<div class="line number34 index33 alt1">&nbsp;</div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Advance both lists and call recursively</code></div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp-&gt;next = sortedIntersect(a-&gt;next,</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">b-&gt;next);</code></div>
<div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">temp;</code></div>
<div class="line number39 index38 alt2"><code class="plain">&#125;</code></div>
<div class="line number40 index39 alt1">&nbsp;</div>
<div class="line number41 index40 alt2"><code class="comments">/* UTILITY FUNCTIONS */</code></div>
<div class="line number42 index41 alt1"><code class="comments">/* Function to insert a node at</code></div>
<div class="line number43 index42 alt2"><code class="comments">the beginging of the linked list */</code></div>
<div class="line number44 index43 alt1"><code class="keyword bold">void</code> <code class="plain">push(</code><code
        class="keyword bold">struct</code> <code class="plain">Node** head_ref, </code><code
        class="color1 bold">int</code> <code class="plain">new_data)</code></div>
<div class="line number45 index44 alt2"><code class="plain">&#123;</code></div>
<div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Allocate node */</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* new_node = (</code><code
        class="keyword bold">struct</code> <code class="plain">Node*)</code><code
        class="functions bold">malloc</code><code class="plain">(</code></div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
        class="plain">Node));</code></div>
<div class="line number50 index49 alt1">&nbsp;</div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Put in the data&nbsp; */</code></div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;data = new_data;</code></div>
<div class="line number53 index52 alt2">&nbsp;</div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Link the old list off the new node */</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;next = (*head_ref);</code></div>
<div class="line number56 index55 alt1">&nbsp;</div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Move the head to point to the new node */</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">(*head_ref) = new_node;</code></div>
<div class="line number59 index58 alt2"><code class="plain">&#125;</code></div>
<div class="line number60 index59 alt1">&nbsp;</div>
<div class="line number61 index60 alt2"><code class="comments">/* Function to print nodes in</code></div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
        class="comments">a given linked list */</code></div>
<div class="line number63 index62 alt2"><code class="keyword bold">void</code> <code
        class="plain">printList(</code><code class="keyword bold">struct</code> <code
        class="plain">Node* node)</code></div>
<div class="line number64 index63 alt1"><code class="plain">&#123;</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(node != NULL)</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number67 index66 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">" "</code> <code
        class="plain">&lt;&lt; node-&gt;data;</code></div>
<div class="line number68 index67 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node = node-&gt;next;</code></div>
<div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number70 index69 alt1"><code class="plain">&#125;</code></div>
<div class="line number71 index70 alt2">&nbsp;</div>
<div class="line number72 index71 alt1"><code class="comments">// Driver code</code></div>
<div class="line number73 index72 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number74 index73 alt1"><code class="plain">&#123;</code></div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Start with the empty lists */</code></div>
<div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* a = NULL;</code></div>
<div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* b = NULL;</code></div>
<div class="line number79 index78 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* intersect = NULL;</code></div>
<div class="line number80 index79 alt1">&nbsp;</div>
<div class="line number81 index80 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Let us create the first sorted</code></div>
<div class="line number82 index81 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">linked list to test the functions</code></div>
<div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">Created linked list will be</code></div>
<div class="line number84 index83 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">1-&gt;2-&gt;3-&gt;4-&gt;5-&gt;6 */</code></div>
<div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 6);</code></div>
<div class="line number86 index85 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 5);</code></div>
<div class="line number87 index86 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 4);</code></div>
<div class="line number88 index87 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 3);</code></div>
<div class="line number89 index88 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 2);</code></div>
<div class="line number90 index89 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 1);</code></div>
<div class="line number91 index90 alt2">&nbsp;</div>
<div class="line number92 index91 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Let us create the second sorted linked list</code></div>
<div class="line number93 index92 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">Created linked list will be 2-&gt;4-&gt;6-&gt;8 */</code></div>
<div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;b, 8);</code></div>
<div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;b, 6);</code></div>
<div class="line number96 index95 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;b, 4);</code></div>
<div class="line number97 index96 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;b, 2);</code></div>
<div class="line number98 index97 alt1">&nbsp;</div>
<div class="line number99 index98 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Find the intersection two linked lists */</code></div>
<div class="line number100 index99 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">intersect = sortedIntersect(a, b);</code></div>
<div class="line number101 index100 alt2">&nbsp;</div>
<div class="line number102 index101 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"\n Linked list containing "</code></div>
<div class="line number103 index102 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&lt;&lt; </code><code class="string">"common items of a &amp; b \n "</code><code
        class="plain">;</code></div>
<div class="line number104 index103 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printList(intersect);</code></div>
<div class="line number105 index104 alt2">&nbsp;</div>
<div class="line number106 index105 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number107 index106 alt2"><code class="plain">&#125;</code></div>
<div class="line number108 index107 alt1">&nbsp;</div>
<div class="line number109 index108 alt2"><code
        class="comments">// This code is contributed by shivanisinghss2110</code></div>
</div>
       </div>
         <div id="tab-content-2" class="tab-content">
         <div class="container">
<div class="line number1 index0 alt2"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
<div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;stdlib.h&gt;</code></div>
<div class="line number3 index2 alt2">&nbsp;</div>
<div class="line number4 index3 alt1"><code class="comments">/* Link list node */</code></div>
<div class="line number5 index4 alt2"><code class="keyword bold">struct</code> <code class="plain">Node &#123;</code>
</div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* next;</code></div>
<div class="line number8 index7 alt1"><code class="plain">&#125;;</code></div>
<div class="line number9 index8 alt2">&nbsp;</div>
<div class="line number10 index9 alt1"><code class="keyword bold">struct</code> <code
        class="plain">Node* sortedIntersect(</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* a,</code></div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* b)</code></div>
<div class="line number13 index12 alt2"><code class="plain">&#123;</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* base case */</code></div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(a == NULL || b == NULL)</code></div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">NULL;</code></div>
<div class="line number17 index16 alt2">&nbsp;</div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* If both lists are non-empty */</code></div>
<div class="line number19 index18 alt2">&nbsp;</div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* advance the smaller list and call recursively */</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(a-&gt;data &lt; b-&gt;data)</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">sortedIntersect(a-&gt;next, b);</code></div>
<div class="line number23 index22 alt2">&nbsp;</div>
<div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(a-&gt;data &gt; b-&gt;data)</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">sortedIntersect(a, b-&gt;next);</code></div>
<div class="line number26 index25 alt1">&nbsp;</div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Below lines are executed only</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// when a-&gt;data == b-&gt;data</code></div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* temp</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">= (</code><code class="keyword bold">struct</code> <code class="plain">Node*)</code><code
        class="functions bold">malloc</code><code class="plain">(</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
        class="plain">Node));</code></div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp-&gt;data = a-&gt;data;</code></div>
<div class="line number33 index32 alt2">&nbsp;</div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* advance both lists and call recursively */</code></div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp-&gt;next = sortedIntersect(a-&gt;next, b-&gt;next);</code></div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">temp;</code></div>
<div class="line number37 index36 alt2"><code class="plain">&#125;</code></div>
<div class="line number38 index37 alt1">&nbsp;</div>
<div class="line number39 index38 alt2"><code class="comments">/* UTILITY FUNCTIONS */</code></div>
<div class="line number40 index39 alt1"><code class="comments">/* Function to insert a node at</code></div>
<div class="line number41 index40 alt2"><code class="comments">the beginging of the linked list */</code></div>
<div class="line number42 index41 alt1"><code class="keyword bold">void</code> <code class="plain">push(</code><code
        class="keyword bold">struct</code> <code class="plain">Node** head_ref, </code><code
        class="color1 bold">int</code> <code class="plain">new_data)</code></div>
<div class="line number43 index42 alt2"><code class="plain">&#123;</code></div>
<div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* allocate node */</code></div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* new_node</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">= (</code><code class="keyword bold">struct</code> <code class="plain">Node*)</code><code
        class="functions bold">malloc</code><code class="plain">(</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
        class="plain">Node));</code></div>
<div class="line number48 index47 alt1">&nbsp;</div>
<div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* put in the data&nbsp; */</code></div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;data = new_data;</code></div>
<div class="line number51 index50 alt2">&nbsp;</div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* link the old list off the new node */</code></div>
<div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;next = (*head_ref);</code></div>
<div class="line number54 index53 alt1">&nbsp;</div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* move the head to point to the new node */</code></div>
<div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">(*head_ref) = new_node;</code></div>
<div class="line number57 index56 alt2"><code class="plain">&#125;</code></div>
<div class="line number58 index57 alt1">&nbsp;</div>
<div class="line number59 index58 alt2"><code
        class="comments">/* Function to print nodes in a given linked list */</code></div>
<div class="line number60 index59 alt1"><code class="keyword bold">void</code> <code
        class="plain">printList(</code><code class="keyword bold">struct</code> <code
        class="plain">Node* node)</code></div>
<div class="line number61 index60 alt2"><code class="plain">&#123;</code></div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(node != NULL) &#123;</code></div>
<div class="line number63 index62 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d "</code><code
        class="plain">, node-&gt;data);</code></div>
<div class="line number64 index63 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node = node-&gt;next;</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number66 index65 alt1"><code class="plain">&#125;</code></div>
<div class="line number67 index66 alt2">&nbsp;</div>
<div class="line number68 index67 alt1"><code class="comments">/* Driver program to test above functions*/</code>
</div>
<div class="line number69 index68 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number70 index69 alt1"><code class="plain">&#123;</code></div>
<div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Start with the empty lists */</code></div>
<div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* a = NULL;</code></div>
<div class="line number73 index72 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* b = NULL;</code></div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* intersect = NULL;</code></div>
<div class="line number75 index74 alt2">&nbsp;</div>
<div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Let us create the first sorted</code></div>
<div class="line number77 index76 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">linked list to test the functions</code></div>
<div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">Created linked list will be</code></div>
<div class="line number79 index78 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">1-&gt;2-&gt;3-&gt;4-&gt;5-&gt;6 */</code></div>
<div class="line number80 index79 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 6);</code></div>
<div class="line number81 index80 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 5);</code></div>
<div class="line number82 index81 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 4);</code></div>
<div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 3);</code></div>
<div class="line number84 index83 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 2);</code></div>
<div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;a, 1);</code></div>
<div class="line number86 index85 alt1">&nbsp;</div>
<div class="line number87 index86 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Let us create the second sorted linked list</code></div>
<div class="line number88 index87 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">Created linked list will be 2-&gt;4-&gt;6-&gt;8 */</code></div>
<div class="line number89 index88 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;b, 8);</code></div>
<div class="line number90 index89 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;b, 6);</code></div>
<div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;b, 4);</code></div>
<div class="line number92 index91 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;b, 2);</code></div>
<div class="line number93 index92 alt2">&nbsp;</div>
<div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Find the intersection two linked lists */</code></div>
<div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">intersect = sortedIntersect(a, b);</code></div>
<div class="line number96 index95 alt1">&nbsp;</div>
<div class="line number97 index96 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"\n Linked list containing common items of a &amp; b \n "</code><code class="plain">);</code>
</div>
<div class="line number98 index97 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printList(intersect);</code></div>
<div class="line number99 index98 alt2">&nbsp;</div>
<div class="line number100 index99 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number101 index100 alt2"><code class="plain">&#125;</code></div>
</div>
             </div>
        
          </div>
  </div>
     <br /> <br /> <br /> <br /> <br />
           </div>
    )
}

export default Gld10
